import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../../messages';
import { CryptoWithdrawComponent } from './components/components/CryptoWithdraw';

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/crypto/$productCode/',
)({
  component: CryptoWithdraw,
});

function CryptoWithdraw() {
  const { productCode } = Route.useParams();
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/withdraw/crypto/2FA"
      />
      <div className="px-6 py-4">
        <CryptoWithdrawComponent productCode={productCode} />
      </div>
    </>
  );
}
